import theme from './theme';

export default {
  palette: {
    primary: theme.app.primaryColors,
    secondary: theme.app.secondaryColors,
  },
  overrides: {
    PrivateTabIndicator: {
      colorSecondary: {
        backgroundColor: theme.app.primaryColors.main,
      },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 0,
      },
    },
  },

};
